<div class="simulator-bar hide1" *ngIf="rootScope.simulationData.isSimulationModeActive">
  <p>Simulation Mode</p>
</div>
<div class="environment-bar hide1" *ngIf="rootScope.invalidENVBanner&&rootScope.isGenesysLoggedIn">
  <p>{{rootScope.Prod_lifeCycle ? constants.PROD_ENV_BANNER:constants.TEST_ENV_BANNER}}</p>
</div>
<div class="header-gradient"></div>
<div class="header" (window:resize)="rootScope.onResize()">
  <div class="divider main-tab">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-lg-2 logo-section">
          <img class="logo" src="../../../../assets/images/Logo.png" width="auto" height="auto" alt="Alight Care Portal" />
        </div>
        <div class="col-md-9 col-lg-10 flex justify-space-between flex-1">
          <div class="tab-container">
            <nav mat-tab-nav-bar disableRipple>
              <button mat-tab-link *ngFor="let mainTab of rootScope.items" (click)="onTabChange(mainTab)"  [disabled]="mainTab.id == 'administration' && (rootScope.isLiveCall || rootScope.checkLiveChatAccount())"
                [active]="rootScope.activeLink == mainTab.id" [title]="mainTab.name | titlecase">
               <span [ngClass]="{'frozen': mainTab.id == 'administration' && (rootScope.isLiveCall || rootScope.checkLiveChatAccount())}">{{ mainTab.name }}</span>
              </button>
            </nav>
            <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
          </div>
          <div class="right-section flex">
            <div class="indicator-container" *ngIf="rootScope.loadUI">
              <span [ngClass]="{
                  green: indicatorClass == 'green',
                  gray: (indicatorClass == 'gray' || rootScope.indicatorClass =='gray'),
                  red: (indicatorClass == 'red'||rootScope.indicatorClass=='red')
                }">
                <i title="Genesys Cloud Indicator" class="fa-solid fa-cloud"> &nbsp; </i>
              </span>
              <span [ngClass]="{
                  green: tbaIndicatorClass == 'green',
                  gray: tbaIndicatorClass == 'gray',
                  red: tbaIndicatorClass == 'red'
                }">
                <i title="TBA Indicator" class="fa-light fa-satellite-dish"></i>
              </span>
              <span [ngClass]="{
                  green: networkIndicatorClass == 'green',
                  yellow: networkIndicatorClass == 'yellow',
                  red: networkIndicatorClass == 'red'
                }">
                <i title="Network Connectivity" class="fa-solid fa-signal-bars"></i>
              </span>
              <span *ngIf="rootScope?.utilityStatusClass==''"><i  title="Runtime Utility Indicator"  class="fa-light fa-gears gray"></i></span>
              <span *ngIf="rootScope?.utilityStatusClass=='red'"><i  title="Runtime Utility Indicator"  class="fa-solid fa-gears red"  ></i></span>
              <span *ngIf="rootScope?.utilityStatusClass=='green'"><i  title="Runtime Utility Indicator"  class="fa-solid fa-gears green"  ></i></span>
            </div>
            <app-user-profile-data-card class="flex"></app-user-profile-data-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="rootScope.activeLink == 'search'" class="childnav">
    <!-- <a href="#"> <strong>Customer Search <i class="fa-light fa-magnifying-glass"></i></strong> </a> -->
    <div class="childnav-container container">
      <nav mat-tab-nav-bar disableRipple class="nav-left">
        <span *ngFor="let tab of rootScope.customerTabs; let index = index">
          <button *ngIf="(tab.id == 0 || tab.id == 1)" mat-tab-link [ngClass]="getClassByValue(tab)"
            (click)="onSecondTabChange(tab.customerSessionId, $event,tab)"
            [active]="rootScope.customerLink == tab.customerSessionId">
            <span *ngIf="tab.iconClass =='fa-light'&&tab.active&&liveIcon(tab, 'call')">
              <i class="fa-phone" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.iconClass =='red'&&tab.active&&liveIcon(tab, 'call')">
              <i class="fa-solid fa-phone" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.iconClass =='green'&&tab.active&&liveIcon(tab, 'call')">
              <i class="fa-solid fa-phone" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="callHollowIcon(tab)">
              <i class="fa-phone fa-light" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="chatHollowIcon(tab)">
              <i class="fa-regular fa-comment "
                [ngClass]="(tab.iconClass=='red' || tab.CS_SECURITY_LEVEL=='1')?'red':'green'"></i>
            </span>
            <span *ngIf="tab.iconClass == 'fa-solid green'&&tab.active&& liveIcon(tab, 'chat')">
              <i class="fa-solid fa-comment" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.iconClass == 'fa-solid red'&&tab.active&& liveIcon(tab, 'chat')">
              <i class="fa-solid fa-comment" [ngClass]="tab.iconClass"></i>
            </span>
            <span
              *ngIf="tab.iconClass != 'fa-solid green' && tab.iconClass != 'fa-solid red' &&tab.active && liveIcon(tab, 'chat')">
              <i class="fa-solid fa-comment" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.idle && !tab.additionalAccount && !rootScope?.checkCallOrChat()">
              <i class="fa-regular fa-clock yellow"></i></span>
            <!-- <span *ngIf="rootScope.customerLink != tab.customerSessionId&&tab?.title" [title]="tab.title | titlecase">{{
                      tab.title.length > rootScope.tabTitleChars &&
                      tab.id != 0 &&
                      rootScope.customerLink != tab.customerSessionId
                      ? (tab.title | titlecase) : (tab.title | titlecase)
                      }}</span>
                    <span *ngIf="rootScope.customerLink == tab.customerSessionId" [title]="tab.title | titlecase">{{
                      tab.title.length > rootScope.activeTabTitleChars && tab.id != 0
                      ? (tab.title | titlecase) : (tab.title | titlecase)
                      }}</span> -->
            <span class="duplicate-tab-span" [title]="tab.title | titlecase">{{tab.title | titlecase
              }}</span>
            <i class="fa-light fa-magnifying-glass duplicate-tab-span" *ngIf="tab.customerSessionId == '0'"></i>
            <button mat-icon-button *ngIf="hideCloseIcon(tab)" (click)="closeTab(index, $event, tab)">
              <i class="fa-solid fa-close"></i>
            </button>
          </button>
        </span>
      </nav>
  
      <nav mat-tab-nav-bar disableRipple
        [ngClass]="{'nav-right-for-unknown': checkForDuplicateSearch(),'nav-right': !checkForDuplicateSearch()}">
        <span *ngFor="let tab of rootScope.customerTabs; let index = index">
          <button *ngIf="!(tab.id == 0 || tab.id == 1)" mat-tab-link [disabled]="!tab.active && tab.id != 0"
            [ngClass]="getClassByValue(tab)" (click)="onSecondTabChange(tab.customerSessionId, $event,tab)"
            [active]="rootScope.customerLink == tab.customerSessionId">
            <span *ngIf="tab.iconClass =='fa-light'&&tab.active&&liveIcon(tab, 'call')">
              <i class="fa-phone" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.iconClass =='red'&&tab.active&&liveIcon(tab, 'call')">
              <i class="fa-solid fa-phone" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.iconClass =='green'&&tab.active&&liveIcon(tab, 'call')">
              <i class="fa-solid fa-phone" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="callHollowIcon(tab)">
              <i class="fa-phone fa-light" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="chatHollowIcon(tab)">
              <i class="fa-regular fa-comment " [ngClass]="(tab.iconClass=='red' || tab.CS_SECURITY_LEVEL=='1')?'red':'green'"></i>
            </span>
            <span *ngIf="tab.iconClass == 'fa-solid green'&&tab.active&& liveIcon(tab, 'chat')">
              <i class="fa-solid fa-comment" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.iconClass == 'fa-solid red'&&tab.active&& liveIcon(tab, 'chat')">
              <i class="fa-solid fa-comment" [ngClass]="tab.iconClass"></i>
            </span>
            <span
              *ngIf="tab.iconClass != 'fa-solid green' && tab.iconClass != 'fa-solid red' &&tab.active && liveIcon(tab, 'chat')">
              <i class="fa-solid fa-comment" [ngClass]="tab.iconClass"></i>
            </span>
            <span *ngIf="tab.idle && !tab.additionalAccount && !rootScope?.checkCallOrChat()">
              <i class="fa-regular fa-clock yellow"></i></span>
            <span *ngIf="rootScope.customerLink != tab.customerSessionId&&tab?.title" [title]="tab.title | titlecase">{{
              tab.title.length > rootScope.tabTitleChars &&
              tab.id != 0 &&
              rootScope.customerLink != tab.customerSessionId
              ? (tab.title | titlecase) : (tab.title | titlecase)
              }}</span>
            <span *ngIf="rootScope.customerLink == tab.customerSessionId" [title]="tab.title | titlecase">{{
              tab.title.length > rootScope.activeTabTitleChars && tab.id != 0
              ? (tab.title | titlecase) : (tab.title | titlecase)
              }}</span>
      
            <i class="fa-light fa-magnifying-glass" *ngIf="tab.customerSessionId == '0'"></i>
            <button mat-icon-button *ngIf="hideCloseIcon(tab)" (click)="closeTab(index, $event, tab)">
              <i class="fa-solid fa-close"></i>
            </button>
          </button>
        </span>
      </nav>
    </div>
  </div>
<section class="error-wrapper hide">
  <f-alert variant="error">There was a problem accessing Simulation Mode. Try again by sliding the toggle to "On”.
  </f-alert>
</section>